import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { QRCodeSVG } from 'qrcode.react';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';
import { showReminderLabel } from '../../lib/invoiceReminderLabel';
import { lineDiscountForDisplay } from '../../lib/lineDiscount';

import FormFields from '../../components/form/fields';
import Input from '../../components/form/input';

@withText(props => ({
    orderNumber: <Text id='input.orderNumber-help'>orderNumber</Text>,
    name: <Text id='input.name-help'>name</Text>,
    description: <Text id='input.description-help'>description</Text>,
    installation: <Text id='input.installation-help'>installation</Text>,
    url: <Text id='input.url-help'>url</Text>,
}))
@observer
class SalePacklist extends Component {
  	constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { week, isNew, drawerLevel, classnameContainer = 'receipt' } = this.props;
        const { sections } = this.state;
        const { customerStore, userStore, saleStore } = this.props.stores;
        const { customer } = userStore;
        const { user, isAdmin } = userStore;

        const darkmode= util.getNestedValue(user, 'settings.darkmode');
        const {
            saleTotal = 0,
            saleTax = 0,
            newSale = {},
            currentPayments = [],
        } = saleStore;
        // const saleIsLocked = !!newSale.paymentMethod;
        // console.log({ newSale })

        const dueDate = new Date(newSale.dueDate || newSale.saleDate || new Date());
        if (customer.invoiceDueDays > 0 && !newSale.dueDate) {
            dueDate.setDate(dueDate.getDate() + customer.invoiceDueDays);
        }
        const { days: daysOverDue } = util.dateDiff(dueDate, new Date());
        const showReminder = showReminderLabel({ daysOverDue, reminders: newSale.reminders });

        const restPayment = saleStore.sumRestPayments(currentPayments, saleStore.sumTotal(newSale.products, false));

        // TICKET-01870: same truthy test as lineTotal(). Segment fields can be stored as "" and
        // must then count as "no segment", or the invoice prints four 0,00 cells for the line.
        const saleHasProductsWithGranularPrice = newSale.products && newSale.products.some(p => p.medicine || p.fee || p.equipment || p.other);
        const saleHasProductsWithSaleDate = newSale.products && newSale.products.some(p => p.saleDate);
        const saleHasProductsWithDiscount = newSale.products && newSale.products.some(p => p.discountAmount > 0);

        const saleIsPaidAndDone = newSale.paidDate || restPayment === 0;

        // console.log('newSale.dueDate', newSale.dueDate)
        // console.log('newSale.saleDate', newSale.saleDate)
        // console.log('dueDate', dueDate)
        if (!newSale.id) {
            return (<>
                <div class='d-flex flex-column justify-content-center align-items-center mt-5'>
                    <h2><Text id='dyrejournal.no-sale'>No sale</Text></h2>
                </div>
            </>);
        }

        return (<>
            <div class={`${classnameContainer} bg-white`}>
                <div class='d-flex flex-column'>
                    <div class='d-flex flex-column align-items-center'>
                        {newSale.status === 1001 ? <>
                            <h2><Text id='dyrejournal.priceoffer'>Price Offer</Text></h2>
                            <Text id='dyrejournal.priceoffer-help'>This is a price offer and should not be paid.</Text>
                        </> : <>
                            {saleIsPaidAndDone ? <>
                                <h2><Text id='dyrejournal.packlist'>Packlist</Text></h2>
                            </> : <>
                                <h2>
                                    <Text id='dyrejournal.invoice'>INVOICE</Text>
                                    {showReminder ? <span class='ms-2'> - Påminnelse</span> : ''}
                                </h2>
                            </>}
                        </>}
                    </div>
                    <div class='d-flex flex-row justify-content-between'>
                        <div class='text-center d-flex align-items-center'>
                            {customer.images && customer.images.length > 0 && <img src={localUtil.displayImg(customer.images[0], this.props, '220x')} class='img-fluid' style='max-height: 100px;' />}
                        </div>
                        <div class='d-flex align-items-center'>
                            <h3 class='font-weight-lighter'>{customer.name}</h3>
                        </div>
                    </div>
                    <div class='d-flex flex-row justify-content-between mt-5'>
                        <div class='d-flex flex-column'>
                            <div class='d-flex flex-row'>
                                <div class='font-weight-light'>
                                    <Text id='dyrejournal.customer-name'>Customer</Text>:
                                </div>
                                <div class='d-flex flex-column ms-2'>
                                    {newSale.visitors && newSale.visitors.length > 0 && newSale.visitors.map((visitor, i) => {
                                        return (<>
                                            <div>
                                                {localUtil.showName(visitor)}
                                            </div>
                                            <div>
                                                {visitor.address}
                                            </div>
                                            <div>
                                                {visitor.postalcode} {visitor.place}
                                            </div>
                                        </>);
                                    })}

                                    {newSale.animals && newSale.animals.length > 0 && newSale.animals.map((animal, i) => {
                                        return (<>
                                            <div>
                                                {animal.name} ({animal.species}/{animal.breed})
                                            </div>
                                        </>);
                                    })}
                                </div>
                            </div>
                            <div class='d-flex flex-row'>
                                <div class='font-weight-light'>
                                    <Text id='dyrejournal.customer-id'>Customer ID</Text>:
                                </div>
                                <div class='ms-2'>
                                    {newSale.visitor || newSale.visitors[0].id}
                                </div>
                            </div>
                        </div>
                        <div class='d-flex flex-column align-items-end'>
                            <div class='d-flex flex-row'><Text id='dyrejournal.date'>Date:</Text> {util.formatDate(newSale.saleDate || new Date(), { hour12: false, hour: '2-digit', minute: '2-digit', locale: 'nb-NO' })}</div>
                            {newSale.status === 1001 ? <>
                                <div class='d-flex flex-row'><Text id='dyrejournal.invoice-id'>Invoice ID:</Text> n/a</div>
                            </> : <>
                                {saleIsPaidAndDone ? <>
                                    <div class='d-flex flex-row'><Text id='dyrejournal.receipt-id'>Receipt ID:</Text> {newSale.saleNumber || 'n/a'}</div>
                                </> : <>
                                    <div class='d-flex flex-row'><Text id='dyrejournal.invoice-id'>Invoice ID:</Text> {newSale.saleNumber || 'n/a'}</div>
                                </>}
                            </>}
                        </div>
                    </div>

                    <hr />

                    <div class='d-flex flex-column mt-5'>
                        <div class=''>
                            <table class='table table-sm table-borderless'>
                                <thead>
                                    <tr>
                                        {saleHasProductsWithSaleDate && <>
                                            <th class='text-muted text-start'><nobr><Text id='dyrejournal.date'>Date</Text></nobr></th>
                                        </>}
                                        <th class='text-end'><Text id='dyrejournal.quantity'>Quantity</Text></th>
                                        <th><Text id='dyrejournal.product-number'>Productnum</Text></th>
                                        <th><Text id='dyrejournal.item'>Item</Text></th>
                                        {saleHasProductsWithGranularPrice ? <>
                                            <th class='text-center'><nobr><Text id='dyrejournal.sale.medicine'>Medicine</Text></nobr></th>
                                            <th class='text-center'><nobr><Text id='dyrejournal.sale.fee'>Fee</Text></nobr></th>
                                            <th class='text-center'><nobr><Text id='dyrejournal.sale.equipment'>Equipment</Text></nobr></th>
                                            <th class='text-center'><nobr><Text id='dyrejournal.sale.other'>Other</Text></nobr></th>
                                        </> : <>
                                            <th class='text-end'><Text id='dyrejournal.price'>Price</Text></th>
                                        </>}
                                        {saleHasProductsWithDiscount && <th class='text-end'><Text id='dyrejournal.sale.discount-amount'>Discount</Text></th>}
                                        <th class='text-end'><Text id='dyrejournal.total'>Total</Text></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {newSale.products && newSale.products.length > 0 && newSale.products.map((product, i) => {
                                        return (<>
                                            <tr>
                                                {saleHasProductsWithSaleDate && <>
                                                    <td>
                                                        {product.saleDate && <>
                                                            {util.formatDate(product.saleDate, { hour12: false, hour: '2-digit', minute: '2-digit', locale: 'nb-NO' })}
                                                        </>}
                                                    </td>
                                                </>}
                                                <td class='text-end'>{product.qty}</td>
                                                <td class='text-end'>{product.productNumber}</td>
                                                <td>
                                                    {product.animal ? <>
                                                        <span class='font-weight-light text-muted me-2'>{product.animal.name}:</span>
                                                    </> : <></>}
                                                    {product.name}
                                                    {product.color ? <>
                                                        <span class='font-weight-light text-muted'> - <Text id='product.color'>Color</Text>: {product.color}</span>
                                                    </> : <></>}
                                                    {product.size ? <>
                                                        <span class='font-weight-light text-muted'> - <Text id='product.size'>Size</Text>: {product.size}</span>
                                                    </> : <></>}
                                                    {product.comment && <>
                                                        <br /><small class='text-muted'>({product.comment})</small>
                                                    </>}
                                                </td>
                                                {product.medicine || product.fee || product.equipment || product.other ? <>
                                                    <td class='text-end'><nobr>{saleStore.linePricePart(product, true, 'medicine')}</nobr></td>
                                                    <td class='text-end'><nobr>{saleStore.linePricePart(product, true, 'fee')}</nobr></td>
                                                    <td class='text-end'><nobr>{saleStore.linePricePart(product, true, 'equipment')}</nobr></td>
                                                    <td class='text-end'><nobr>{saleStore.linePricePart(product, true, 'other')}</nobr></td>
                                                </> : <>
                                                    <td class='text-end' colspan={saleHasProductsWithGranularPrice ? 4 : 1}><nobr>{util.format(product.price, 2)}</nobr></td>
                                                </>}
                                                {saleHasProductsWithDiscount && <>
                                                    <th class='text-end'>
                                                        <nobr>{lineDiscountForDisplay(product) ? `${util.format(lineDiscountForDisplay(product), 2, ',', ' ')}` : ''}</nobr>
                                                    </th>
                                                </>}
                                                <td class='text-end'><nobr>{saleStore.lineTotal(product)}</nobr></td>
                                            </tr>
                                        </>);
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class='d-flex flex-row justify-content-end'>
                        <div class='d-flex flex-column mt-5 w-50 justify-content-end'>
                            <table class='table table-sm table-borderless'>
                                <tbody>
                                    <tr>
                                        <td class='text-end'><Text id='dyrejournal.total'>Total</Text></td>
                                        <td class='text-end'>{saleStore.sumTotal(newSale.products)}</td>
                                    </tr>
                                    <tr>
                                        <td class='text-end'><Text id='dyrejournal.of-which-vat'>Of which VAT</Text></td>
                                        <td class='text-end'>{saleStore.sumVat(newSale.products)}</td>
                                    </tr>
                                    {saleIsPaidAndDone && <>
                                        <tr>
                                            <td class='text-end'><Text id='dyrejournal.paid-with'>Paid with</Text></td>
                                            <td class='text-end'><i class={saleStore.getPaymentMethodIcon(newSale.paymentMethod)} /> {newSale.paymentMethod}</td>
                                        </tr>
                                        <tr>
                                            <td class='text-end'><Text id='dyrejournal.paid-date'>Paid date</Text></td>
                                            <td class='text-end'>{util.formatDate(newSale.paidDate, { hour12: false, hour: '2-digit', minute: '2-digit',  locale: 'nb-NO' })}</td>
                                        </tr>
                                    </>}

                                    {currentPayments && currentPayments.length > 1 && <>
                                        <tr>
                                            <td class='text-end'><Text id='dyrejournal.partial-payment-total'>Partial payment total</Text></td>
                                            <td class='text-end'>{saleStore.sumTotalPayments(currentPayments)}</td>
                                        </tr>
                                    </>}
                                    {restPayment > 0 && <>
                                        <tr>
                                            <td class='text-end'><Text id='dyrejournal.partial-payment-rest-payment'>Rest payment</Text></td>
                                            <td class='text-end'>{saleStore.sumRestPayments(currentPayments, saleStore.sumTotal(newSale.products, true))}</td>
                                        </tr>
                                    </>}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {newSale.paymentUuidv4 ? <>
                        <div class='d-flex flex-column mt-5'>
                            <div class='d-flex flex-row justify-content-center'>

                                <QRCodeSVG value={`${newSale.uuidv4}`} size={256} />

                            </div>
                            <div class='d-flex flex-row justify-content-center'>
                                <small>Denne QR-koden brukes som billett. Ta vare på den dersom du har kjøpt en billett til ett arrangement.</small>
                            </div>

                        </div>
                    </> : <></>}

                    {currentPayments && currentPayments.length > 0 && <>
                        <div class='d-flex flex-column mt-5'>
                            <div class=''>
                                <span class='font-weight-bolder'><Text id='dyrejournal.payments'>Payments</Text></span>
                                <div class={`table-responsive`}>
                                    <table class='table table-sm table-borderless'>
                                        <thead>
                                            <tr>
                                                <th class='text-muted text-start'><nobr><Text id='dyrejournal.partial-payment-date'>Date</Text></nobr></th>
                                                <th class='text-muted text-center'><nobr><Text id='dyrejournal.partial-payment-method'>Method</Text></nobr></th>
                                                <th class='text-muted text-end'><nobr><Text id='dyrejournal.sale.amount'>Amount</Text></nobr></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentPayments.map((e, idx) => <>
                                                <tr>
                                                    <td>{util.formatDate(e.paidDate, { hour12: false, hour: '2-digit', minute: '2-digit', locale: 'nb-NO' })}</td>
                                                    <td class='text-center'><i class={saleStore.getPaymentMethodIcon(e.paymentMethod)} /> {e.paymentMethod}</td>
                                                    <td class='text-end'>{util.format(e.amount, 2, ',', ' ')}</td>
                                                </tr>
                                            </>)}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </>}

                    {!saleIsPaidAndDone && <>
                        <hr class='mt-2' />
                        {customer.invoiceInfo ? <>
                            <p style="margin: 0;"><b>{customer.invoiceInfo}</b></p>
                        </> : <></>}
                        <table width="100%" cellpadding="0" cellspacing="0">
                            <tbody>
                                {showReminder ? <>
                                    <tr>
                                        <td colspan='2'>
                                            <span class='font-weight-bold me-2'>Påminnelse.</span>
                                            <Text id='dyrejournal.invoice-overdue' fields={{ days: daysOverDue }}>Invoice is overdue by {daysOverDue} days.</Text>
                                        </td>
                                    </tr>
                                </> : <></>}
                                <tr>
                                    <td width="120" style="color: #808080; font-weight: 100;">
                                        <Text id='dyrejournal.due-date'>Due date</Text>:
                                    </td>
                                    <td>
                                        {util.formatDate(dueDate, { locale: 'nb-NO' })}
                                    </td>
                                </tr>
                                {currentPayments && currentPayments.length > 0 ? <>
                                    <tr>
                                        <td width="120" style="color: #808080; font-weight: 100;">
                                            <Text id='dyrejournal.amount'>Amount</Text>:
                                        </td>
                                        <td>
                                            {saleStore.sumRestPayments(currentPayments, saleStore.sumTotal(newSale.products, false))}
                                        </td>
                                    </tr>
                                </> : <>
                                    <tr>
                                        <td width="120" style="color: #808080; font-weight: 400; font-size: 1.5em;">
                                            <Text id='dyrejournal.amount'>Amount</Text>:
                                        </td>
                                        <td style='font-weight: 700; font-size: 1.5em;'>
                                            {saleStore.sumTotal(newSale.products)}
                                        </td>
                                    </tr>
                                </>}
                                <tr>
                                    <td width="120" style="color: #808080; font-weight: 100;">
                                        <Text id='dyrejournal.paid-to'>Paid to</Text>:
                                    </td>
                                    <td>
                                        {customer.name}
                                    </td>
                                </tr>
                                <tr>
                                    <td width="120" style="color: #808080; font-weight: 100;">
                                        <Text id='dyrejournal.account-number'>Account number</Text>:
                                    </td>
                                    <td>
                                        {customer.invoiceAccount}
                                        {customer.invoiceIban && <>
                                            <br />
                                            <Text id='dyrejournal.iban'>IBAN:</Text> {customer.invoiceIban}
                                        </>}
                                        {customer.invoiceBic && <>
                                            <br />
                                            <Text id='dyrejournal.bic'>BIC:</Text> {customer.invoiceBic}
                                        </>}
                                    </td>
                                </tr>
                                {customer.invoiceHidePaymentReference ? <></> : customer.invoicePaymentReferenceText ? <>
                                    <tr>
                                        <td colspan='2' style="color: #808080;">
                                            {customer.invoicePaymentReferenceText}
                                        </td>
                                    </tr>
                                </> : <>
                                    <tr>
                                        <td width="120" style="color: #808080; font-weight: 100;">
                                            <Text id='dyrejournal.mark-payment-with'>Mark payment with</Text>:
                                        </td>
                                        <td>
                                            {newSale.status === 1001 ? <>
                                                <Text id='dyrejournal.invoice-id'>Invoice ID:</Text>: n/a
                                            </> : <>
                                                <Text id='dyrejournal.invoice-id'>Invoice ID:</Text>: {newSale.saleNumber || 'n/a'}
                                            </>}
                                        </td>
                                    </tr>
                                </>}
                            </tbody>
                        </table>
                    </>}

                    <div class='d-flex flex-row justify-content-between mt-5'>
                        <div class='d-flex flex-column'>
                            <small>
                                <div class='mb-2 font-weight-bold'><Text id='dyrejournal.business-register'>The Business Register</Text></div>
                                <div>{customer.orgNumber}</div>
                                <div>{customer.name}</div>
                                {customer.orgNumber2 && <div>{customer.orgNumber}</div>}
                                {customer.name2 && <div>{customer.name}</div>}
                            </small>
                        </div>
                        <div class='d-flex flex-column'>
                            <small>
                                <div class='mb-2 font-weight-bold'><Text id='dyrejournal.address'>Address</Text></div>
                                <div>{customer.address}</div>
                                <div>{customer.postalcode} {customer.place}</div>
                            </small>
                        </div>
                        <div class='d-flex flex-column'>
                            <small>
                                <div class='mb-2 font-weight-bold'>{customer.fax ? <Text id='dyrejournal.phone-fax'>Phone/Fax</Text> : <Text id='dyrejournal.phone'>Phone</Text>}</div>
                                <div>{customer.phone}</div>
                                {customer.fax ? <div>{customer.fax}</div> : null}
                            </small>
                        </div>
                        <div class='d-flex flex-column'>
                            <small>
                                <div class='mb-2 font-weight-bold'><Text id='dyrejournal.internett'>Internet</Text></div>
                                <div>{customer.url}</div>
                                <div>{customer.email}</div>
                            </small>
                        </div>
                    </div>

                </div>

            </div>
        </>);
    }
}

export default SalePacklist;
